const initialState = {
  projects: []
};

// -------------------------------------------------------
// -------------------------------------------------------
const reducer = (state = initialState, action) => {

  let projects = JSON.parse(JSON.stringify(state.projects));
  // -------------------------------------------------------
  switch (action.type) {

    // -------------------------------------------------------
    // -------------------------------------------------------
    case "CLEAR_PROJECTS":
      return initialState;

    // -------------------------------------------------------
    // -------------------------------------------------------
    case "SET_PROJECTS":
      return {
        ...state,
        projects: action.projects,
      };
    
    // --------------------------------------------------------------
    // --------------------------------------------------------------
    case "ERASE_PROJECT":
      projects = projects.filter((project) => project._id !== action.projectid);
      return {
        ...state,
        projects
      };

    // --------------------------------------------------------------
    default:
      return state;
  }
};

export default reducer;
